import { Button } from '@/components/Button/Button';
import styles from './WorkshopKit.module.scss';

/**
 * Materials pointer. Only ever renders a link the server chose to hand to this
 * client: repository details must never reach an attendee (BR-AP6/NFR-AP1), so
 * when no link is present the card says so rather than guessing a source.
 */
export function WorkshopKit({ repoLink }: { repoLink?: string | undefined }) {
  return (
    <aside className={styles.kit}>
      <span className={styles.icon} aria-hidden="true">
        ↓
      </span>
      <div>
        <strong>Workshop kit</strong>
        <p>Templates and references for this workshop in one place.</p>
        {repoLink ? (
          <Button size="sm" variant="ghost" onClick={() => window.open(repoLink, '_blank', 'noopener')}>
            Open materials ↗
          </Button>
        ) : (
          <span className={styles.none}>No materials published for this workshop.</span>
        )}
      </div>
    </aside>
  );
}
